module.exports = __webpack_public_path__ + "static/img/why-4.887e6e19.jpg";